import { render, staticRenderFns } from "./SiteApprovalStatus.vue?vue&type=template&id=a37507d0&"
import script from "./SiteApprovalStatus.vue?vue&type=script&lang=js&"
export * from "./SiteApprovalStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports